export {
    fetchFeaturedAndSortedPortalsData,
    convertToFeaturedAndSortedPortalsResponse,
} from './featured-and-sorted-portals';
